module.exports = __webpack_public_path__ + "media/images/download/e-book09-8209962d8aebe9eb7c16649dcd280b70.png";